import React, {useState} from "react";
import cabinetStyle from "../mentorCabinet/MentorCabinet.module.css";
import MetaphoricCardsStack from "./MetaphoricCardsStack";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import * as AssetsService from "../../api/AssetsService";
import {defaultMetaphoricCardsCards} from "./DefaultMetaphoricCards";
import {useTranslation} from "react-i18next";

function MetaphoricCardsMentorCabinet() {
    const [availableCards, setAvailableCards] = useState([])
    const { t, i18n } = useTranslation();

    useEffectOnce(() => {
        AssetsService.getAvailableMetaphoricCards(setAvailableCards, () => {
            setAvailableCards(defaultMetaphoricCardsCards)
        })
    })


    return (
        <>
            <div className={cabinetStyle.mainPageContainerCards}>
                {availableCards.map((stack) => {
                    return <MetaphoricCardsStack
                        key={stack.id}
                        titleLink={stack.title_card_img}
                        stackNumber={stack.id}
                        name={i18n.language === "en" ? stack.name_en : stack.name_ua}
                        numOfCards={stack.number_of_cards}
                        authorLink={stack.author_link}
                        authorName={i18n.language === "en" ? stack.author_name_en : stack.author_name_ua}
                        stackPrefix={stack.card_img_url_prefix}
                        cardExtension={stack.card_img_url_extension}
                    ></MetaphoricCardsStack>
                })}
            </div>
        </>
    )
}

export default MetaphoricCardsMentorCabinet